import { colorSet } from '@theme';
import { LoadingSpinner, Text } from '..';
import { PlusPrimaryIcon } from '@assets/icons';
import { IOptionList } from '@types';

interface IAIRecommendedChildOptionValueProps {
  isVisible: boolean; //컴포넌트 자체 visibility 분기. false일 시 로딩스피너도 안 보이도록 처리
  isLoading: boolean;
  recommendedChildOptionValue?: IOptionList | null;
  recommendedCharacterNumber?: string | null; //child option 중 인원수 관련은 별개의 prop으로 전달
  onClick: () => void;
}

export const AIRecommendedChildOptionValue = (props: IAIRecommendedChildOptionValueProps) => {
  const { isVisible, isLoading, recommendedChildOptionValue, recommendedCharacterNumber, onClick } = props;

  const recommendedOptions = recommendedChildOptionValue
    ? Object.values(recommendedChildOptionValue).filter((option) => option.isSelected)
    : [];

  return (
    <div>
      {isVisible ? (
        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              {recommendedChildOptionValue || recommendedCharacterNumber ? (
                <div
                  onClick={onClick}
                  style={{
                    height: 28,
                    border: `1px solid ${colorSet.primaryMain}`,
                    borderRadius: '6px',
                    padding: '0px 10px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer'
                  }}
                >
                  {recommendedCharacterNumber ? (
                    <Text variant="body1" color={colorSet.primaryMain}>
                      {recommendedCharacterNumber}
                    </Text>
                  ) : (
                    <>
                      <Text variant="body1" color={colorSet.primaryMain}>
                        {recommendedOptions
                          .slice(0, 2)
                          .map((option) => option.name)
                          .join(', ')}
                      </Text>
                      {recommendedOptions.length > 2 ? (
                        <Text variant="body1" color={colorSet.gray400}>
                          &nbsp;{`+${recommendedOptions.length - 2} more`}
                        </Text>
                      ) : null}
                    </>
                  )}

                  <PlusPrimaryIcon style={{ marginLeft: '2px' }} />
                </div>
              ) : null}
            </>
          )}
        </>
      ) : null}
    </div>
  );
};
